import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { AuthService } from '@bya/auth/services/authentication.service';
import { VigenciaSistemaService } from 'app/services/vigencia-sistema.service';
import { VigenciaFiscalService } from 'app/main/datos-basicos/services/vigencia-fiscal-service.service';
import { VigenciaFiscal } from 'app/main/datos-basicos/entities/vigencia-fiscal';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { ChangePasswordModalComponent } from 'app/layout/change-password-user/components/change-password-modal/change-password-modal.component';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { HelpDeskService } from '@bya/base/services/helpDesk.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];

    //@bya Open id Connect Security
    name: string;
    isAuthenticated: string;
    subscription: Subscription;

    //@bya Vigencia del sistema
    vigencias: VigenciaFiscal[];
    vigenciaSistema: VigenciaFiscal;


    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     * @param {AuthService} _authService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private authService: AuthService,
        public _vigenciaSistemaService: VigenciaSistemaService,
        private _vigenciaFiscalService: VigenciaFiscalService,
        private _matDialog: MatDialog,
        private _appConfig: AppConfigService,
        private _helpDeskService:HelpDeskService
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    //@ bya
    ///
    private subscribeAuthService() {
        this.subscription = this.authService.authNavStatus$.subscribe(reportAuth => {

            this.isAuthenticated = reportAuth.status;
            if (reportAuth.user){

                this.name = reportAuth.user.profile.name;
                this._helpDeskService.setUserShowTikect(
                    reportAuth.user.profile.given_name,
                    reportAuth.user.profile.name, 
                    reportAuth.user.profile.email,
                    reportAuth.user.profile.phone_number);
            }
        });

    }

    getVigencias(): void {
        let loading = this._matDialog.open(LoadingComponent, { panelClass: 'loading' });
        this._vigenciaFiscalService.getAll()
            .subscribe(vigencias => {

                vigencias = vigencias.filter(t => t.estado != "PE");

                if (vigencias.length > 0 && this._vigenciaSistemaService.vigencia == null) {
                    this._vigenciaSistemaService.establecerVigencia(vigencias.find((t) => { return t.estado == "AC" }));
                }
                this.vigencias = vigencias;
                loading.close();
            });
    }

    seleccionarVigencia(vigenciaNueva: VigenciaFiscal) {
        if (this.vigenciaSistema == null || this.vigenciaSistema.id != vigenciaNueva.id) {
            this._vigenciaSistemaService.establecerVigencia(vigenciaNueva);
        }
    }

    signout() {
        this.authService.signout();
    }

    CambiarPassword() {
        this._matDialog.open(ChangePasswordModalComponent, { panelClass: 'change-password-dialog' });
    }

    public EsAdministrador(): boolean {
        return this.authService.hasRole("IdentityApi_Seguridad");
    }
    public IrAIdenityAdmin() {
        window.open(`${this._appConfig.IdentityAdminUrl}/login`);
    }


    private unSubscribeAuthService() {
        // prevent memory leak when component is destroyed
        this.subscription.unsubscribe();
    }


    /// End @bya 


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang });

        this.subscribeAuthService();


        this.getVigencias();
        this.vigenciaSistema = this._vigenciaSistemaService.vigencia;

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.unSubscribeAuthService();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }
}
